
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './UserSlice';
import adminReducer from './AdminSlice';
import { 
  getApproversReducer, getHistoryReducer, getRequestReducer, 
  getUserReducer, getVendorReducer, getCategoryReducer, 
  getPodataReducer, getRequestIdReducer, getRequestReportsReducer, 
  getDashboardRequestReducer 
} from "./DataReducer";

const store = configureStore({
  reducer: {
    user: userReducer,
    admin: adminReducer,
    getHistory: getHistoryReducer,
    getApprovers: getApproversReducer,
    getUsers: getUserReducer,
    getRequests: getRequestReducer,
    getVendor: getVendorReducer,
    getCategory: getCategoryReducer,
    getPodata: getPodataReducer,
    getDataById: getRequestIdReducer,
    getRequestReports: getRequestReportsReducer,
    getDashboardRequest: getDashboardRequestReducer
  },
  // configureStore automatically adds thunk and enables Redux DevTools
});

export default store;
